
import React, { useState } from 'react'
import { compose } from 'widgets-shared/core'
import { Button, ButtonGroup, FormControlLabel, Grid, Switch } from '@mui/material'
import { withTranslations } from 'widgets-shared/core'
import { marketsTranslations } from 'smartstream-widgets/constants/markets'
import { withStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { TranslationFunction } from 'smartstream-widgets/types/sharedModule/core'
import { MarketType } from '../types'
import { PropTranslations } from 'smartstream-widgets/types/widget'
import { getDefaultTheme } from 'smartstream-widgets/utils/getDefaultTheme'

type Props = {
  activeTab: string,
  classes: {
    [K in string]: string
  },
  disableLiveGamesSwitch: boolean,
  initialMarketType: MarketType | null,
  marketTypeHandler: ((marketType: MarketType) => void),
  marketTypes: Array<string>,
  liveGamesHandler: ((live: boolean) => void),
  translations: PropTranslations
}

const styles = (theme: Theme) => createStyles({
  buttonGroup: {
    height: 39,
    marginRight: 26,
    '& $button': {
      transitionProperty: 'background-color, box-shadow'
    }
  },
  button: {},
  buttonLabel: {
    textTransform: 'capitalize'
  },
  root: {},
  switchContainer: {
    height: 22
  },
  switchLabel: {
    color: theme.palette.grey['600'],
    fontSize: '9px',
    textTransform: 'uppercase'
  }
})

export function GridFilters(props: Props) {
  const {
    activeTab,
    classes,
    disableLiveGamesSwitch = false,
    initialMarketType,
    marketTypeHandler,
    marketTypes = [],
    liveGamesHandler,
    translations
  } = props

  const defaultMarketTypes: Array<MarketType> = activeTab === "635"
    ? ['raceWinner', 'top3', 'top5']
    : ['moneyLine', 'spread', 'total']
  const sortedMarketTypes = defaultMarketTypes.includes(initialMarketType) ?
    defaultMarketTypes.reduce((result: Array<MarketType>, market) => {
      initialMarketType === market ? result.unshift(market) : result.push(market)
      return result
    }, []) : defaultMarketTypes
  const firstActive = marketTypes.includes(initialMarketType) ? initialMarketType : marketTypes[0]
  const [activeMarket, setActiveMarket] = useState(firstActive)

  return (
    <Grid className={classes.root} alignItems='center' container wrap='nowrap' data-testid='grid-filters'>
      <ButtonGroup color='primary' className={classes.buttonGroup}>
        {sortedMarketTypes.map(market => (
          <Button
            key={market}
            className={classes.button}
            data-ht-category='filter'
            data-ht-action={`show ${market} odds`}
            data-ht-label={translations[market]}
            onClick={() => {
              setActiveMarket(market)
              marketTypeHandler && marketTypeHandler(market)
            }}
            disabled={!marketTypes.includes(market)}
            variant={market === activeMarket ? 'contained' : 'outlined'}
          >
            <span className={classes.buttonLabel}>
              {translations[market]}
            </span>
          </Button>
        ))}
      </ButtonGroup>
      {!disableLiveGamesSwitch &&
        <FormControlLabel
          control={<Switch
            color='primary'
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              liveGamesHandler && liveGamesHandler(event.target.checked)
            }
          />}
          classes={{ label: classes.switchLabel, root: classes.switchContainer }}
          label={translations.liveGames}
        />
      }
    </Grid>
  )
}

export default compose(
  withStyles(styles, { name: 'GridFilters', defaultTheme: getDefaultTheme }),
  withTranslations((t: TranslationFunction) => {
    return {
      ...marketsTranslations(t),
      liveGames: t('liveGames.translation', {
        defaultValue: 'Live Games',
        context: 'Text for live games switch inside Odds Comparison Grid widget'
      })
    }
  })
)(GridFilters)
